import { Component, EventEmitter, Input, OnInit, Output, NgModule } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
type ITransactionType = { TransactionTypeId: number; TransactionType: string };
import { subMonths } from 'date-fns';

@Component({
  selector: 'bookings-component',
  templateUrl: '../sharedTemplates/bookings.component.html',
})
export class BookingsComponent implements OnInit {
  bookingsList = [];
  transactionTypes: { id: number; name: string }[] = [];
  selectedTransType: number;
  years = [];
  months = [];

  today = new Date();
  selectedYear = new Date().getFullYear();
  selectedMonth = new Date().getMonth();
  selectableDate = [];
  selectedSlipDate;
  translator = new TranslatePipe(this._LocalizationService);

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,
    private _router: Router
  ) {}

  ngOnInit() {
    const today = new Date();
    const defaultMonth = today.getMonth();
    const defaultYear = today.getFullYear();

    this.years.push({
      year: defaultYear,
    });
    this.years.push({
      year: defaultYear - 1,
    });
    this.years.push({
      year: defaultYear - 2,
    });

    this.months = [
      { id: 0, name: 'January' },
      { id: 1, name: 'February' },
      { id: 2, name: 'March' },
      { id: 3, name: 'April' },
      { id: 4, name: 'May' },
      { id: 5, name: 'June' },
      { id: 6, name: 'July' },
      { id: 7, name: 'August' },
      { id: 8, name: 'September' },
      { id: 9, name: 'October' },
      { id: 10, name: 'November' },
      { id: 11, name: 'December' },
    ];

    // this.selectedYear = defaultYear;
    // this.selectedMonth = defaultMonth;
    this.selectableDate = [
      { id: 1, name: this.translator.transform('Last_1_Months', null) },
      { id: 3, name: this.translator.transform('Last_3_Months', null) },
      { id: 6, name: this.translator.transform('Last_6_Months', null) },
      { id: 12, name: this.translator.transform('Last_12_Months', null) },
    ];
    this.selectedSlipDate = 1;
    this.selectedTransType = 0;
  }

  ngAfterViewInit() {
    this._ApiService.getTranscationsTypes().then((x: ITransactionType[]) => {
      if (x && x.length > 0) {
        this.transactionTypes = [{ id: 0, name: 'All' }, ...x.map((i: ITransactionType) => ({ id: i.TransactionTypeId, name: i.TransactionType }))];
      }
      this.getBookings();
    });

    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setNavbarTitle('Bookings');
  }

  getBookings() {
    // çektiğimiz data uzadığı için manuel loading kurdum
    this._UiHelper.setLoadingDialog(true);

    this._ApiService
      .getBookings(this.selectedMonth, this.selectedYear, this.selectedTransType)
      .then(x => {
        this.bookingsList = x;
        this._UiHelper.setLoadingDialog(false);
      })
      .catch(err => {
        console.error(err);
        this._UiHelper.setLoadingDialog(false);
      });
  }
  onBookingDateChange(Value: string): void {
    if (Value) {
      this.selectedMonth = new Date(subMonths(this.today, Number(Value))).getMonth() + 1;
      this.selectedYear = new Date(subMonths(this.today, Number(Value))).getFullYear();
      this.getBookings();
    }
  }
  onTransTypeChange(newValue) {
    ////console.log(newValue);
    this.selectedTransType = newValue;
    this.getBookings();
  }
  onYearsChange(newValue) {
    ////console.log(newValue);
    this.selectedYear = newValue;
    this.getBookings();
  }
  onMonthsChange(newValue) {
    ////console.log(newValue);
    this.selectedMonth = newValue;
    this.getBookings();
  }

  // https://bet3k.atlassian.net/browse/N2-269 Maddesi için yazıldı. SP gelince eklenecek
  transactionHistorySubmit() {
    this._ApiService.getTransactionHistory().then((x: any) => {
      const translator = new TranslatePipe(this._LocalizationService);
      const t_message = translator.transform('b3000_transaction_history_message', null);
      this._UiHelper.successSnackBar(t_message, '');
    });
  }
}
